export default __webpack_public_path__ + "static/media/watermark.eb17fd17.jpeg";